import OrbitAPISchema from "../orbitAPISchema.json" with { type: "json" };
import { AjvAPIValidator } from "./ajvAPIValidator.js";
export class OrbitAPIValidator extends AjvAPIValidator {
    constructor(config) {
        super(config, OrbitAPISchema);
    }
}
//# sourceMappingURL=orbitAPIValidator.js.map